import type { ReactiveController, ReactiveControllerHost } from "lit";
import { SocketClient } from "../lib/socket-client";
import type { ServerEvent } from "../types/chat";

export interface SocketControllerOptions {
  buildUrl: () => string;
  onEvent: (e: ServerEvent) => void;
  onOpen?: () => void;
  onClose?: () => void;
  onError?: () => void;
}

export class SocketController implements ReactiveController {
  private host: ReactiveControllerHost;
  private client?: SocketClient;
  private opts: SocketControllerOptions;

  wsConnected = false;
  reconnecting = false;
  firstLoad = true;

  constructor(host: ReactiveControllerHost, opts: SocketControllerOptions) {
    this.host = host;
    this.opts = opts;
    host.addController(this);
  }

  hostConnected(): void {}
  hostDisconnected(): void {
    this.disconnect();
  }

  connect(): void {
    this.client = new SocketClient(this.opts.buildUrl(), {
      onOpen: () => {
        this.wsConnected = true;
        this.reconnecting = false;
        this.firstLoad = false;
        this.opts.onOpen?.();
        this.host.requestUpdate();
      },
      onClose: () => {
        this.wsConnected = false;
        this.reconnecting = true;
        this.firstLoad = false;
        this.opts.onClose?.();
        this.host.requestUpdate();
      },
      onError: () => {
        this.wsConnected = false;
        this.reconnecting = true;
        this.firstLoad = false;
        this.opts.onError?.();
        this.host.requestUpdate();
      },
      onEvent: (e) => this.opts.onEvent(e),
    });
    this.client.connect();
  }

  disconnect(): void {
    this.client?.disconnect();
  }

  sendMessage(msg: unknown): void {
    this.client?.sendMessage(msg as never);
  }

  requestAudioOrVideo(req: unknown): void {
    this.client?.requestAudioOrVideo(req as never);
  }
}
